import React, {
  forwardRef,
  useRef,
  useState,
  useImperativeHandle,
  useEffect,
  useMemo,
} from 'react';
import { useRequest } from 'ahooks';
import {
  Button,
  Form,
  Select,
  SelectOptionWithGroup,
  Text,
  Bubble,
  Icon,
  Switch,
} from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import DatalabGrid from "@/pages/datalab/components/DatalabGrid";
import type { IGetTableInfoDto, ITableColumnDto } from '@dbl/services/dataSource';
import { getTableInfoList } from '@dbl/services/dataSource';
import { DateGranularity } from '@dbl/core/date';
import { DBColumnType } from '@/pages/datalab/components/SortableDrag/typeDefine';
import { Step } from './addSource';
import {
  JoinType,
  ITableJoinColumn,
  ITableJoinRelation, ITableJoinCondition,
} from './interface';
import { ReactSortable } from 'react-sortablejs';
import './join_select.scss';
import { getJoinRelationClazz } from '@/pages/datalab/pages/Multidimensional/utils';
import Abnormal from "@home/components/Abnormal";
import { FieldTypeIcon } from '@dbl/core/dataSource';
import {getLocalText} from "@/pages/datalab/utils/utils";
import { ADD_ANALYSIS } from '@/pages/datalab/pages/Home/GettingStart';
const SourceSteep2 = (props: any, ref: any) => {
  const {
    isEn,
    oldJoinTables,
    oldJoinRelations,
    curStep,
    setCurStep,
    selectTables,
    setSelectTables,
    formatMessage,
    showSelfJoin,
    selfJoin,
    setSelfJoin,
    setTemplateId,
    setStatusOfStep2,
    gameCode
  }: {
    isEn: boolean;
    formatMessage: Function;
    oldJoinTables: IGetTableInfoDto[];
    oldJoinRelations: ITableJoinRelation[];
    curStep: Step;
    setCurStep: Function;
    selectTables: any[];
    setSelectTables: Function;
    showSelfJoin: boolean;
    selfJoin: boolean;
    setSelfJoin: Function;
    setTemplateId?: Function;
    setStatusOfStep2: Function;
    gameCode: string;
  } = props;

  // 拖拽使用的数据表，由于拖拽有4个槽位，所以需要额外定义一个空对象来补完4个对象
  const [joinTables, setJoinTables] = useState<IGetTableInfoDto[]>([]);
  const saveJoinTablesObj = useRef<IGetTableInfoDto[]>([]);
  const [joinRelations, setJoinRelations] = useState<ITableJoinRelation[]>([]);
  const { runAsync } = useRequest(getTableInfoList, {
    manual: true,
    // 请不要随意修改这个key，全局上下文唯一key,后来者需要注意，使用这个hooks，返回的Promise是贯穿上下文的，也就是说只要run一遍，在组件的各个地方都能拿到最新返回值，把这个hooks放置在顶层，遵循数据自上而下流动
    cacheKey: ADD_ANALYSIS,
  });
  const [resortStatus, setResortStatus] = useState(false);
  const [pageStatus, setPageStatus] = useState('normal');
  const [showSelectError, setShowSelectError] = useState(false);
  const [refreshRelationUI, setRefreshRelationUI] = useState<number>(0);

  useImperativeHandle(ref, () => ({
    // 若关联关系和关联字段没有选择，error返回true
    getTableInfosAndTableJoinRelations: () => {
      let error = false;
      try {
        joinRelations.forEach((relation, index) => {
          if (index === 0) return;
          if (!relation.connect_type) {
            error = true;
            throw new Error();
          }
          if (!relation.on) {
            error = true;
            throw new Error();
          }
          relation.on.forEach((joinColumn: ITableJoinColumn) => {
            if (
              !joinColumn.left_condition.column ||
              !joinColumn.right_condition.column
            ) {
              error = true;
              throw new Error();
            }
            if (
              DBColumnType.getBaseType(joinColumn.left_condition.type) !==
              DBColumnType.getBaseType(joinColumn.right_condition.type)
            ) {
              error = true;
              throw new Error();
            }
          });
        });
      } catch (e) {}
      if (error) {
        setShowSelectError(true);
      }
      return {
        error,
        joinTables: joinTables.filter((item) => item.table_id !== ''),
        joinRelations,
      };
    },
  }));

  useEffect(() => {
    // 如果有传入初值，使用初值初始化
    if (oldJoinTables?.length > 0 && oldJoinRelations?.length > 0) {
      let isReload = false;
      try {
        oldJoinRelations.forEach((relation, index) => {
          if (index !== 0) {
            if (!relation.on || relation.on.length === 0) {
              isReload = true;
              throw new Error();
            }
          }
        });
      } catch (e) {}
      if (isReload) {
        return;
      }

      const joinTables: IGetTableInfoDto[] = [...oldJoinTables];
      if (oldJoinTables.length === 3 && oldJoinRelations.length === 3) {
        if (oldJoinTables[0].table_id === oldJoinRelations[0].table_id) {
          joinTables.splice(2, 0, {
            customize_name: "", customize_name_en: "", database_uuid: "", kind: "",
            table_id: ''
          });
        } else {
          joinTables.push({
            table_id: '', customize_name: "", customize_name_en: "", database_uuid: "", kind: ""
          });
        }
      }
      setJoinTables(joinTables);
      setJoinRelations(JSON.parse(JSON.stringify(oldJoinRelations)));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    if (curStep !== Step.Two) {
      return;
    }
    const newTables = joinTables
      .filter((item) => item.table_id !== '')
      .map((item) =>
        selectTables.find((select) => select.table_id === item.table_id),
      );
    setSelectTables(newTables);
    if (newTables.length === 0) {
      setCurStep(Step.One);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinTables]);

  useEffect(() => {
    if (selectTables.length === 0 || curStep !== Step.Two) {
      return;
    }

    let isReload = false;
    const newTables = joinTables.filter((item) => item.table_id !== '');
    if (selectTables.length === newTables.length) {
      selectTables.forEach((table, index) => {
        if (newTables[index].table_id !== table.table_id) {
          isReload = true;
        }
      });
      isReload =
        isReload ||
        !(
          joinRelations.length === selectTables.length &&
          joinRelations
            .map((item) => item.table_id)
            .every((tableId) =>
              selectTables.some((elem) => elem.table_id === tableId),
            )
        );
    } else {
      isReload = true;
    }
    if (!isReload) {
      return;
    }
    
    setPageStatus('loading');
    runAsync(selectTables.map((item) => item.table_id), gameCode)
      .then((res) => {
      
        const joinTables: IGetTableInfoDto[] = [];
        const onlyOneTable = selectTables.length === 1;
        selectTables.forEach((item, index) => {
          const tableRes = (res || []).find(
            (tableRes: any) => tableRes.table_id === item.table_id,
          );
          if (tableRes) {
            joinTables.push({
              only_one_table: onlyOneTable,
              table_id: tableRes.table_id,
              table_name: tableRes.table_name,
              customize_name: tableRes.customize_name,
              customize_name_en: tableRes.customize_name_en,
              table_code: `t${index}`,
              table_desc: tableRes.table_desc,
              cycle: tableRes.cycle,
              creator: tableRes.creator,
              label: tableRes.label,
              sub_label: tableRes.sub_label,
              column_list: tableRes.column_list,
              driver: item.driver,
              database_uuid: item.database_uuid,
              template_list: tableRes.template_list,
              db_name: tableRes?.db_name,
              kind: tableRes?.kind,
            });
          }
        });
        setTemplateId?.(joinTables[0]?.template_list?.[0]?.task_id);
        if (joinTables.length === 3) {
          joinTables.push({
            customize_name: "", customize_name_en: "", database_uuid: "", kind: "",
            table_id: ''
          });
        }
        setJoinTables(joinTables);
        setPageStatus(joinTables?.length === 0 ? 'error' : 'normal');
      })
      .catch(() => {
        setPageStatus('error');
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curStep]);
  useEffect(() => {
    setStatusOfStep2(pageStatus);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageStatus]);

  // 获取默认的联表字段
  const getJoinOnList = (tables: IGetTableInfoDto[], indexArr: number[]) => {
    const joinColumn = (columnInfo: ITableColumnDto | undefined) => ({
      left_condition: {
        table_code: tables[indexArr[0]].table_code,
        table_id: tables[indexArr[0]].table_id,
        column: columnInfo?.name,
        type: columnInfo?.type,
      },
      right_condition: {
        table_code: tables[indexArr[1]].table_code,
        table_id: tables[indexArr[1]].table_id,
        column: columnInfo?.name,
        type: columnInfo?.type,
      },
      operation: columnInfo ? '=' : '',
    });
    const list = tables[indexArr[0]].column_list?.reduce(
      (previousValue: any[], currentValue: ITableColumnDto) => {
        const columnInfo = tables[indexArr[1]].column_list?.find(
          (item) =>
            item.name === currentValue.name && item.type === currentValue.type,
        );
        if (
          columnInfo &&
          (columnInfo.is_sensitive ||
            columnInfo.is_common_dimension ||
            columnInfo.is_metric ||
            columnInfo.is_dimension)
        ) {
          previousValue.push(joinColumn(columnInfo));
        }
        return previousValue;
      },
      [],
    );
    if (list?.length === 0) {
      list.push(joinColumn(undefined));
    }
    return list;
  };

  // 存储表之间的关联关系
  useEffect(() => {
    // const joinRelations = useMemo<ITableJoinRelation[]>(() => {

    if (curStep !== Step.Two) {
      return;
    }
    const joinRelations: ITableJoinRelation[] = [];
    if (joinTables.length === 4) {
      // 三张表情况
      if (joinTables[2].table_id === '') {
        // 左下角是空槽
        const joinRelation1: ITableJoinRelation = {
          table_name: joinTables[0].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[0].table_id,
          table_code: joinTables[0].table_code,
          granularity: joinTables[0].cycle ?? DateGranularity.DAY,
          connect_type: '',
          on: [],
        };
        joinRelations.push(joinRelation1);
        const joinRelation2: ITableJoinRelation = {
          table_name: joinTables[1].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[1].table_id,
          table_code: joinTables[1].table_code,
          granularity: joinTables[1].cycle ?? DateGranularity.DAY,
          connect_type: JoinType.LeftJoin,
          on: getJoinOnList(joinTables, [0, 1]),
        };
        joinRelations.push(joinRelation2);
        const joinRelation3: ITableJoinRelation = {
          table_name: joinTables[3].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[3].table_id,
          table_code: joinTables[3].table_code,
          granularity: joinTables[3].cycle ?? DateGranularity.DAY,
          connect_type: JoinType.LeftJoin,
          on: getJoinOnList(joinTables, [1, 3]),
        };
        joinRelations.push(joinRelation3);
      } else {
        const joinRelation1: ITableJoinRelation = {
          table_name: joinTables[2].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[2].table_id,
          table_code: joinTables[2].table_code,
          granularity: joinTables[2].cycle ?? DateGranularity.DAY,
          connect_type: '',
          on: [],
        };
        joinRelations.push(joinRelation1);
        const joinRelation2: ITableJoinRelation = {
          table_name: joinTables[0].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[0].table_id,
          table_code: joinTables[0].table_code,
          granularity: joinTables[0].cycle ?? DateGranularity.DAY,
          connect_type: JoinType.LeftJoin,
          on: getJoinOnList(joinTables, [2, 0]),
        };
        joinRelations.push(joinRelation2);
        const joinRelation3: ITableJoinRelation = {
          table_name: joinTables[1].table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: joinTables[1].table_id,
          table_code: joinTables[1].table_code,
          granularity: joinTables[1].cycle ?? DateGranularity.DAY,
          connect_type: JoinType.LeftJoin,
          on: getJoinOnList(joinTables, [0, 1]),
        };
        joinRelations.push(joinRelation3);
      }
    } else if (joinTables.length === 2) {
      // 两张表情况
      joinTables.forEach((table, index) => {
        const joinRelation: ITableJoinRelation = {
          table_name: table.table_name,
          customize_name: joinTables[0].customize_name,
          customize_name_en: joinTables[0].customize_name_en,
          table_id: table.table_id,
          table_code: table.table_code,
          granularity: table.cycle ?? DateGranularity.DAY,
          connect_type: index !== 0 ? JoinType.LeftJoin : '',
          on: index !== 0 ? getJoinOnList(joinTables, [index - 1, index]) : [],
        };
        joinRelations.push(joinRelation);
      });
    } else if (joinTables.length === 1) {
      const joinRelation: ITableJoinRelation = {
        table_name: joinTables[0].table_name,
        customize_name: joinTables[0].customize_name,
        customize_name_en: joinTables[0].customize_name_en,
        table_id: joinTables[0].table_id,
        table_code: joinTables[0].table_code,
        granularity: joinTables[0].cycle ?? DateGranularity.DAY,
        connect_type: '',
        on: [],
      };
      joinRelations.push(joinRelation);
    }
    setJoinRelations(joinRelations);
    setShowSelectError(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinTables]);

  const relationArrays = useMemo(() => {
    const arrays: ITableJoinRelation[] = [];
    if (joinTables.length === 4) {
      // 三张表情况
      if (joinTables[2].table_id === '') {
        // 左下角是空槽
        arrays[0] = { ...joinRelations[1] };
        arrays[1] = { ...joinRelations[2] };
      } else {
        arrays[2] = { ...joinRelations[1] };
        arrays[0] = { ...joinRelations[2] };
      }
    } else if (joinTables.length === 2) {
      // 两张表情况
      arrays[0] = { ...joinRelations[1] };
    }
    return arrays;
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(joinRelations),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(joinTables),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refreshRelationUI,
  ]);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const JoinRelationType = [
    {
      value: JoinType.LeftJoin,
      icon: 'left-join',
      text: formatMessage('left_join'),
    },
    {
      value: JoinType.RightJoin,
      icon: 'right-join',
      text: formatMessage('right_join'),
    },
    {
      value: JoinType.InnerJoin,
      icon: 'init-join',
      text: formatMessage('inner_join'),
    },
    {
      value: JoinType.FullJoin,
      icon: 'all-join',
      text: formatMessage('full_join'),
    },
  ];
  // 判断是否显示自关联按钮
  // 1. showSelfJoin 代表业务页面级别控制是否显示; 比如: 多维分析页面显示, 号码包提取页面不显示
  // 2. 首次进入时, 只勾选了一个表时, joinTables长度为1, 显示
  // 3. 但是开启自关联按钮后, joinTables的长度为2了, 所以当table_id相同时, 显示
  const isShowSelfJoin =
    showSelfJoin &&
    (joinTables.length === 1 ||
      (joinTables.length === 2 &&
        joinTables[0].table_id === joinTables[1].table_id));
  return (
    <Abnormal
      isLoading={pageStatus === 'loading'}
      isError={pageStatus === 'error'}
      component={(
        <div className="add-setting">
          {isShowSelfJoin ? (
            <div className="join-setting-self">
              {formatMessage('self_join')}
              <Bubble
                dark
                content={
                  <div
                    style={{ width: 100, padding: '0px 4px', lineHeight: '22px' }}
                  >
                    <p>{formatMessage('self_join_des')}</p>
                    <p>{formatMessage('self_join_demo')}</p>
                  </div>
                }
                placement={'top'}
              >
                <Icon type="info" />
              </Bubble>
              <Switch
                value={selfJoin}
                onChange={(value) => {
                  setSelfJoin(value);
                  if (value) {
                    joinTables[0].only_one_table = false;
                    setJoinTables([
                      joinTables[0],
                      { ...joinTables[0], table_code: 't1' },
                    ]);
                  } else {
                    joinTables[0].only_one_table = true;
                    setJoinTables([joinTables[0]]);
                  }
                }}
              />
            </div>
          ) : (
            ''
          )}
    
          <div
            className="setting-box"
            style={{ height: joinTables.length <= 2 ? 100 : 196 }}
          >
            <ReactSortable<any>
              setList={(list: any[]) => {
                if (list.length === 0) {
                  return;
                }
                saveJoinTablesObj.current = list;
              }}
              list={joinTables}
              className="datalab-join-setting-tables-container"
              handle={'.item'}
              filter={'.drag-disable'}
              preventOnFilter={false}
              animation={200}
              delay={100}
              forceFallback={true}
              onStart={() => {
                setResortStatus(true);
              }}
              onEnd={(_evt) => {
                setResortStatus(false);
                if (saveJoinTablesObj.current.length === 4) {
                  // 如果右上角元素是空，将左下角元素和右上角元素做替换
                  if (saveJoinTablesObj.current[1].table_id === '') {
                    [saveJoinTablesObj.current[1], saveJoinTablesObj.current[2]] = [
                      saveJoinTablesObj.current[2],
                      saveJoinTablesObj.current[1],
                    ];
                  }
                }
                saveJoinTablesObj.current.forEach((table, index) => {
                  if (index === 3) {
                    // eslint-disable-next-line no-param-reassign
                    index = 2;
                  }
                  // eslint-disable-next-line no-param-reassign
                  table.table_code = `t${index}`;
                });
          
                let isReload = false;
                if (saveJoinTablesObj.current.length === joinTables.length) {
                  saveJoinTablesObj.current.forEach((table, index) => {
                    if (joinTables[index].table_id !== table.table_id) {
                      isReload = true;
                    }
                  });
                } else {
                  isReload = true;
                }
                if (!isReload && !selfJoin) {
                  return;
                }
          
                setJoinTables(saveJoinTablesObj.current);
              }}
            >
  
              {
                joinTables?.[0] ? (
                  <div
                    className={`item${
                      joinTables[0].table_id === '' ? ' drag-disable' : ''
                    }`}
                    key={joinTables[0].table_id + joinTables[0].table_code}
                    style={{ opacity: joinTables[0].table_id ? '' : '0' }}
                  >
                    <ItemBox
                      tableInfo={joinTables[0]}
                      onDelete={(e) => {
                        e.stopPropagation();
                        setJoinTables((oldJoinTables) => {
                          oldJoinTables.splice(0, 1);
                          const joinTables: IGetTableInfoDto[] = [];
                          oldJoinTables.forEach((table, index) => {
                            if (table.table_id === '') return;
                            // eslint-disable-next-line no-param-reassign
                            table.table_code = `t${index}`;
                            joinTables.push(table);
                          });
                          joinTables.length === 1 && (joinTables[0].table_code = '');
                          return joinTables;
                        });
                        setSelfJoin(false);
                      }}
                      isEn={isEn}
                    />
                  </div>
                ) : <></>
              }
              
              {
                joinTables?.[1] ? (
                  <div
                    className={`item${
                      joinTables[1].table_id === '' ? ' drag-disable' : ''
                    } table2`}
                    key={joinTables[1].table_id + joinTables[1].table_code}
                    style={{ opacity: joinTables[1].table_id ? '' : '0' }}
                  >
                    <div className={`port-first ${resortStatus ? 'down-grey' : ''}`}>
                      {
                        getJoinRelationClazz(relationArrays?.[0]?.connect_type)?.map((type, index) => (<SvgIcon type={type} key={type+index} className={index === 0 ? 'port-direction' : 'port-relation'}/>))
                      }
                    </div>
                    <ItemBox
                      tableInfo={joinTables[1]}
                      onDelete={(e) => {
                        e.stopPropagation();
                        setJoinTables((oldJoinTables) => {
                          oldJoinTables.splice(1, 1);
                          const joinTables: IGetTableInfoDto[] = [];
                          oldJoinTables.forEach((table, index) => {
                            if (table.table_id === '') return;
                            // eslint-disable-next-line no-param-reassign
                            table.table_code = `t${index}`;
                            joinTables.push(table);
                          });
                          return joinTables;
                        });
                        setSelfJoin(false);
                      }}
                      isEn={isEn}
                    />
                    
                  </div>
                ) : <></>
              }
              
              {
                joinTables?.[2] ? (
                  <div
                    className={`item${
                      joinTables[2].table_id === '' ? ' drag-disable' : ''
                    } table3`}
                    key={joinTables[2].table_id + joinTables[2].table_code}
                    style={{ opacity: joinTables[2].table_id ? '' : '0' }}
                  >
                    {
                      joinTables[2].table_id ? (<div className={`port-four ${resortStatus ? 'down-grey' : ''}`}>
                        {
                          getJoinRelationClazz(relationArrays?.[2]?.connect_type)?.map((type, index) => (<SvgIcon type={type} key={type} className={index === 0 ? 'port-direction' : 'port-relation'}/>))
                        }
                      </div>) : ''
                    }
                    
                    <ItemBox
                      tableInfo={joinTables[2]}
                      onDelete={(e) => {
                        e.stopPropagation();
                        setJoinTables((oldJoinTables) => {
                          oldJoinTables.splice(2, 1);
                          const joinTables: IGetTableInfoDto[] = [];
                          oldJoinTables.forEach((table, index) => {
                            if (table.table_id === '') return;
                            // eslint-disable-next-line no-param-reassign
                            table.table_code = `t${index}`;
                            joinTables.push(table);
                          });
                          return joinTables;
                        });
                        setSelfJoin(false);
                      }}
                      isEn={isEn}
                    />
                  </div>
                ) : <></>
              }
              
              {
                joinTables?.[3] ? (
                  <div
                    className={`item${
                      joinTables[3].table_id === '' ? ' drag-disable' : ''
                    }`}
                    key={joinTables[3].table_id + joinTables[3].table_code}
                    style={{ opacity: joinTables[3].table_id ? '' : '0' }}
                  >
                    {
                      joinTables[3].table_id ? (<div className={`port-four ${resortStatus ? 'down-grey' : ''}`}>
                        {
                          getJoinRelationClazz(relationArrays?.[1]?.connect_type)?.map((type, index) => (
                            <SvgIcon type={type} key={type}
                              className={index === 0 ? 'port-direction' : 'port-relation'}/>))
                        }
                      </div>) : ''
                    }
                    
                    <ItemBox
                      tableInfo={joinTables[3]}
                      onDelete={(e) => {
                        e.stopPropagation();
                        setJoinTables((oldJoinTables) => {
                          oldJoinTables.splice(3, 1);
                          const joinTables: IGetTableInfoDto[] = [];
                          oldJoinTables.forEach((table, index) => {
                            if (table.table_id === '') return;
                            // eslint-disable-next-line no-param-reassign
                            table.table_code = `t${index}`;
                            joinTables.push(table);
                          });
                          return joinTables;
                        });
                        setSelfJoin(false);
                      }}
                      isEn={isEn}
                    />
                  </div>
                ) : <></>
              }
            
            </ReactSortable>
            
            {/* 关系箭头  右链接：right-otherJoin  左链接：left-otherJoin  全连接：all-otherJoin   内链接：init-otherJoin*/}
            {/* 关系icon  右链接：right-join  左链接：left-join  全连接：all-join   内链接：init-join**/}
          
          </div>
          {(joinRelations.filter((_, index) => index !== 0) || []).map(
            (relation: ITableJoinRelation, index) => (
              <ItemChange
                key={relation.table_id + relation.table_code}
                setRefreshRelationUI={setRefreshRelationUI}
                relation={relation}
                relations={joinRelations}
                joinTables={joinTables}
                index={index}
                JoinRelationType={JoinRelationType}
                showSelectError={showSelectError}
                formatMessage={formatMessage}
                isEn={props.isEn}
              />
            ),
          )}
        </div>
      )}
      style={{height: 600}}
    />
  );
};

export default forwardRef(SourceSteep2);

const ItemChange = (props: {
  relation: ITableJoinRelation;
  relations: ITableJoinRelation[];
  joinTables: IGetTableInfoDto[];
  setRefreshRelationUI: Function;
  index: number;
  JoinRelationType: any[];
  showSelectError: boolean;
  formatMessage: Function;
  isEn: boolean;
}) => {
  const {
    relation,
    relations,
    joinTables,
    index,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    JoinRelationType,
    showSelectError,
    setRefreshRelationUI,
    formatMessage,
    isEn,
  } = props;
  const [isChange, setChange] = useState(true);

  const joinRelationTypeOption = JoinRelationType.map((type) => ({
    value: type.value,
    text: (
      <div className="change-item">
        <SvgIcon type={type.icon} className="change-item-img" />
        <span className="change-item-text">{type.text}</span>
      </div>
    ),
  }));
  
  const leftTable = joinTables.find((table) => table.table_id === relations[index].table_id);
  const rightTable = joinTables.find((table) => table.table_id === relations[index+1].table_id);
  return (
    <div className="setting-change">
      <div className="setting-flex">
        <div>
          <span
            onClick={() => {
              setChange(!isChange);
            }}
          >
            <SvgIcon
              type="point-down"
              className={isChange ? 'action-icon' : 'setting-icon'}
            />
            <span className="setting-text">{`${relations[index].table_code}-${
              relations[index + 1].table_code
            }`}</span>
          </span>
          <Select
            className="setting-select"
            appearance="button"
            matchButtonWidth
            options={joinRelationTypeOption}
            value={relation.connect_type}
            // placeholder={formatMessage({
            //   id: 'analysis_add_source_relation_select',
            // })}
            onChange={(value) => {
              relation.connect_type = value;
              setRefreshRelationUI((refreshUI: number) => refreshUI + 1);
            }}
          />
        </div>
      </div>
      <div
        className={
          isChange ? 'setting-context height-nomal' : 'setting-context height-0'
        }
      >
        <Form>
          <Form.Item
            label={formatMessage('joining_field')}
            style={{ fontWeight: 'bold' }}
          >
            <DatalabGrid
              className="setting-context-item"
              style={{ marginTop: 3, fontWeight: 'normal' }}
              colCount={3}
              gap={10}
              verticalAlign={'start'}
              columnWidthMode={['fit-content', 'minmax']}
            >
              <Text
                className={'item-text'}
                dblGridConfig={{ align: 'left' }}
                overflow
                tooltip
              >
                {getLocalText(isEn, leftTable?.customize_name, leftTable?.customize_name_en, leftTable?.table_name)}
              </Text>
              <div></div>
              <Text
                className={'item-text'}
                overflow
                tooltip
                dblGridConfig={{align: 'left' }}
              >
                {getLocalText(isEn, rightTable?.customize_name, rightTable?.customize_name_en, rightTable?.table_name)}
              </Text>
              
              {(relation.on || []).map((joinColumn, index) => (
                <ItemSelect
                  key={index}
                  joinColumn={joinColumn}
                  joinColumnList={relation.on}
                  joinTables={joinTables}
                  setRefreshRelationUI={setRefreshRelationUI}
                  showSelectError={showSelectError}
                  formatMessage={formatMessage}
                  // eslint-disable-next-line react/prop-types
                  isEn={props.isEn}
                />
              ))}
            </DatalabGrid>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
const ItemSelect = ({
  joinColumn,
  joinColumnList,
  joinTables,
  setRefreshRelationUI,
  showSelectError,
  formatMessage,
  isEn
}: {
  joinColumn: ITableJoinColumn;
  joinColumnList: ITableJoinColumn[];
  joinTables: IGetTableInfoDto[];
  setRefreshRelationUI: Function;
  formatMessage: Function;
  showSelectError: boolean;
  isEn: boolean;
}) => {
  function getRelationItemBodySelectOption(
    condition: ITableJoinCondition,
    isEn: boolean,
  ): SelectOptionWithGroup[] {
    return (
      joinTables.find((table) => table.table_id === condition.table_id)
        ?.column_list || []
    ).map((field) => ({
      value: field.name,
      text: (<div className={'dbl-exit-filter-column_option'}><SvgIcon className={FieldTypeIcon[field.type]} type={FieldTypeIcon[field.type] || "abc"}/><span>{getLocalText(isEn ,field.display_name, field.display_name_en, field.name)}</span></div>),
  
    }));
  }

  function addRelationItemBody(joinColumnList: ITableJoinColumn[]) {
    joinColumnList.push({
      left_condition: {
        table_id: joinColumnList[0].left_condition.table_id,
        table_code: joinColumnList[0].left_condition.table_code,
        column: '',
      },
      right_condition: {
        table_id: joinColumnList[0].right_condition.table_id,
        table_code: joinColumnList[0].right_condition.table_code,
        column: '',
      },
      operation: '',
    });
    setRefreshRelationUI((refreshUI: number) => refreshUI + 1);
  }

  function deleteRelationItemBody(
    joinColumn: ITableJoinColumn,
    joinColumnList: ITableJoinColumn[],
  ) {
    if (joinColumnList.length === 1) {
      // eslint-disable-next-line no-param-reassign
      joinColumnList[0].operation = '';
      // eslint-disable-next-line no-param-reassign
      joinColumnList[0].left_condition.column = '';
      // eslint-disable-next-line no-param-reassign
      joinColumnList[0].left_condition.type = '';
      // eslint-disable-next-line no-param-reassign
      joinColumnList[0].right_condition.column = '';
      // eslint-disable-next-line no-param-reassign
      joinColumnList[0].right_condition.type = '';
    } else {
      const index = joinColumnList.indexOf(joinColumn);
      if (index >= 0) {
        joinColumnList.splice(index, 1);
      }
    }
    setRefreshRelationUI((refreshUI: number) => refreshUI + 1);
  }

  function getRelationSelectStatus(value?: string): 'success' | 'error' {
    return !showSelectError || value ? 'success' : 'error';
  }

  function getRelationItemBodySelectLeftErrorMsg(
    left_condition: ITableJoinCondition,
  ): string {
    return !showSelectError || left_condition.column
      ? ''
      : formatMessage('relation_select_info');
  }

  function getRelationItemBodySelectRightStatus(
    left_condition: ITableJoinCondition,
    right_condition: ITableJoinCondition,
  ): 'success' | 'error' {
    if (
      left_condition.column &&
      right_condition.column &&
      DBColumnType.getBaseType(left_condition.type) !==
        DBColumnType.getBaseType(right_condition.type)
    ) {
      return 'error';
    }
    if (!showSelectError) {
      return 'success';
    }
    if (!right_condition.column) {
      return 'error';
    }
    return 'success';
  }

  function getRelationItemBodySelectRightErrorMsg(
    left_condition: ITableJoinCondition,
    right_condition: ITableJoinCondition,
  ): string {
    if (
      left_condition.column &&
      right_condition.column &&
      DBColumnType.getBaseType(left_condition.type) !==
        DBColumnType.getBaseType(right_condition.type)
    ) {
      return formatMessage('relation_not_match');
    }
    if (!showSelectError) {
      return '';
    }
    if (!right_condition.column) {
      return formatMessage('relation_select_info');
    }
    return '';
  }

  return (
    <>
      <Form.Item
        status={getRelationSelectStatus(joinColumn.left_condition.column)}
        message={getRelationItemBodySelectLeftErrorMsg(
          joinColumn.left_condition,
        )}
        showStatusIcon={false}
      >
        <Select
          appearance="button"
          options={getRelationItemBodySelectOption(joinColumn.left_condition, isEn)}
          value={
            joinColumn.left_condition.column
              ? joinColumn.left_condition.column
              : ''
          }
          matchButtonWidth
          className="item-select"
          placeholder={formatMessage('relation_select')}
          searchable
          searchPlaceholder={formatMessage('relation_search')}
          onChange={(value) => {
            // eslint-disable-next-line no-param-reassign
            joinColumn.operation = '=';
            // eslint-disable-next-line no-param-reassign
            joinColumn.left_condition.column = value;
            // eslint-disable-next-line no-param-reassign
            joinColumn.left_condition.type = joinTables
              .find(
                (table) =>
                  table.table_id === joinColumn.left_condition.table_id,
              )
              ?.column_list?.find((column) => column.name === value)?.type;
            setRefreshRelationUI((refreshUI: number) => refreshUI + 1);
          }}
        />
      </Form.Item>
      <span className="item-text-icons">=</span>
      <Form.Item
        status={getRelationItemBodySelectRightStatus(
          joinColumn.left_condition,
          joinColumn.right_condition,
        )}
        message={getRelationItemBodySelectRightErrorMsg(
          joinColumn.left_condition,
          joinColumn.right_condition,
        )}
        showStatusIcon={false}
      >
        <Select
          appearance="button"
          options={getRelationItemBodySelectOption(joinColumn.right_condition, isEn)}
          value={
            joinColumn.right_condition.column
              ? joinColumn.right_condition.column
              : ''
          }
          matchButtonWidth
          className="item-select"
          placeholder={formatMessage('relation_select')}
          searchable
          searchPlaceholder={formatMessage('relation_search')}
          onChange={(value) => {
            // eslint-disable-next-line no-param-reassign
            joinColumn.operation = '=';
            // eslint-disable-next-line no-param-reassign
            joinColumn.right_condition.column = value;
            // eslint-disable-next-line no-param-reassign
            joinColumn.right_condition.type = joinTables
              .find(
                (table) =>
                  table.table_id === joinColumn.right_condition.table_id,
              )
              ?.column_list?.find((column) => column.name === value)?.type;
            setRefreshRelationUI((refreshUI: number) => refreshUI + 1);
          }}
        />
        {joinColumnList.length > 1 ? (
          <Button
            className="item-btn"
            type="link"
            onClick={() => deleteRelationItemBody(joinColumn, joinColumnList)}
          >
            {formatMessage('delete')}
          </Button>
        ) : (
          ''
        )}
        <Button
          className="item-btn"
          type="link"
          onClick={() => addRelationItemBody(joinColumnList)}
        >
          {formatMessage('add')}
        </Button>
      </Form.Item>
    
    </>
  );
};

const ItemBox = (props: {
  isEn: boolean;
  tableInfo: IGetTableInfoDto;
  onDelete: (e: any) => void;
}) => {
  const tableName = getLocalText(props.isEn, props?.tableInfo?.customize_name, props?.tableInfo?.customize_name_en, props?.tableInfo?.table_name);
  
  return (
    <div className="item-box">
      <div className="item-box-left">
        <SvgIcon type="drag-icon" className="item-box-hover"/>
        <span className="item-box-num">{props?.tableInfo.only_one_table ? '' : props?.tableInfo.table_code}</span>
      </div>
      <div className="item-box-context">
        <Bubble placement="top-start" dark content={tableName}>
          <div className="context-text">{tableName}</div>
        </Bubble>
        <div className="context-desc">{props?.tableInfo.table_desc}</div>
      </div>
      <div
        onClick={(e) => {
          props?.onDelete?.(e);
        }}
      >
        <SvgIcon className="item-box-icon" type="clonse" />
      </div>
    </div>
  );
};
